import gql from 'graphql-tag';

export default gql`
  query BoardsRelatedToProductQuery($ids: [Int!], $pageSize: Int) {
    boardsRelatedToProduct(ids: $ids, pageSize: $pageSize) {
      id
      __typename
      mainBoardAsset {
        id
        asset {
          id
          url
        }
      }
      boardProductCount
      designer {
        id
        firstName
        photo
        vanityId
      }
      room {
        id
        roomType {
          id
          type
        }
      }
      subStyles {
        id
        name
      }
    }
  }
`;
